import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { GalleryService } from '../../services/gallery.service';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { map } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.css']
})
export class GalleryComponent implements OnInit {

  public archivoForm = new FormGroup({
    archivo: new FormControl(null, Validators.required),
  });
  
  //public mensajeArchivo = 'No hay un archivo seleccionado';
  public datosFormulario = new FormData();
  public nombreArchivo = '';
  public typefile = '';
  // public URLPublica = '';
  public porcentaje = 0;
  public finalizado = false;

  sizes = ['400x400', '800x800'];

  obj = {
    fecha: null,
    name: '',
    filename: '',
    original: '',
    sizes: [],
    typefile: '',
    url:''
  }

  ds_gallery;
  arrFiles;

  showGallery = false;

  // Retorna Objeto imagen seleccionada
  @Output() objSeleccionado = new EventEmitter();

  constructor(
    private _gallery: GalleryService,
    private router: Router
  ) { }

  ngOnInit(): void {
    //this.getImages();
    this.consultarImagenes();
  }

  seleccionarImagen(obj){
    this.objSeleccionado.emit(obj);
  }

  //Evento que se gatilla cuando el input de tipo archivo cambia
  public cambioArchivo(event) {
    if (event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        
        this.typefile = event.target.files[i].type;
        this.nombreArchivo = event.target.files[i].name;
        this.datosFormulario.delete('archivo');
        this.datosFormulario.append('archivo', event.target.files[i], event.target.files[i].name)
      }
    } else {
      //this.mensajeArchivo = 'No hay un archivo seleccionado';
    }
  }
  
  //Sube el archivo a Cloud Storage
  async subirArchivo() {

    if(!this.nombreArchivo){
      Swal.fire({
        icon: 'info',
        title: 'Falta seleccionar un archivo'
      })

      return;
    }

    // Busca si ya existe el archivo
    let buscar = this.ds_gallery.find( data => data.filename == this.nombreArchivo)
    if(buscar){

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: '¡El archivo '+ this.nombreArchivo + ' ya existe!',
        footer: 'El archivo no se puede subir'
      })

      return;
    }

    return await this.upload();
  }

  async upload(){
    if(!this.nombreArchivo) return;

    let archivo = this.datosFormulario.get('archivo');
    
    // Armado de Obj para database
    this.obj.name = this.nombreArchivo.replace(/\.[^/.]+$/, "");
    this.obj.original = this.nombreArchivo;
    this.obj.sizes = this.getSizesNames(this.nombreArchivo);
    this.obj.filename = this.obj.sizes.find( obj => obj.size == '400x400')['name']; // Tamaño Base 400px x 400px
    this.obj.typefile = this.typefile;


    Swal.fire({
      icon: 'info',
      title: 'Generando miniaturas',
      text: 'Por favor, espere...',
    });
    Swal.showLoading();

   let tarea = this._gallery.tareaCloudStorage(this.nombreArchivo, archivo);

    //Guardar y generar miniiaturas
    let carga = await new Promise( (resolve, reject) => {

      tarea.percentageChanges().subscribe((porcentaje) => {
        this.porcentaje = Math.round(porcentaje);
        if (this.porcentaje == 100) {
          resolve(true)
        } 
      });

    })
    
    // Guardar info de imagen
    if(carga){

      // Esperar 8 segundos para que el storage genere las miniaturas.
      setTimeout(()=> {

        try {
          let referencia = this._gallery.referenciaCloudStorage(this.obj.filename);
          referencia.getDownloadURL().subscribe((URL) => {
              this.obj.url = URL;
              this.obj.fecha = new Date();
              this.guardar(this.obj);
          });
          this.nombreArchivo = null;
          this.archivoForm.reset();
          this.finalizado = true;
          Swal.close();
          this.goGallery();
        } catch (error) {
          console.log("miErrorCatch", {error});
          Swal.close();
        }

      },8000)

    }else{
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No finalizo la carga',
      });
    }
    
  }

  goGallery(){
    this.showGallery = !this.showGallery;
  }

  getSizesNames(filename:string){
    let name = "";
    let extension = "";
    let array = [];

    name = filename.replace(/\.[^/.]+$/, "");
    extension = filename.split('.').pop();

    this.sizes.forEach( data => {
      array.push({ 
        size: data,
        name: name + '_' + data + '.' + extension
       });
    });

    return array;
  }


  consultarImagenes(){
    this._gallery.getAll().snapshotChanges().pipe(
      map( changes =>
        changes.map( d =>
          ({ uid: d.payload.doc.id, ...d.payload.doc.data() })
        )
      )
    ).subscribe( res => {
      this.ds_gallery = res;
    })
  }

  borrarImagen(obj){
    Swal.fire({
      title: 'Eliminar Categoría',
      html: "¿Quieres eliminar la imagen <strong>"+ obj.filename + "</strong>?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#009045',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        // buscar miniaturas por obj.filename
        let arrEncontrado = this.ds_gallery.find( data => data.filename == obj.filename );
        arrEncontrado.sizes.forEach( data => {
          this._gallery.deleteElement(obj.uid, data.name);
        })
      }
    });
  }

  guardar(obj){
    this._gallery.addElement(obj);
  }



}
